import { render, staticRenderFns } from "./propostaCard.vue?vue&type=template&id=05357a6c&scoped=true"
import script from "./propostaCard.vue?vue&type=script&lang=js"
export * from "./propostaCard.vue?vue&type=script&lang=js"
import style0 from "./propostaCard.vue?vue&type=style&index=0&id=05357a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05357a6c",
  null
  
)

export default component.exports